import React,{useState, useEffect} from 'react';
import {GoogleMap, useLoadScript, Marker, InfoWindow} from '@react-google-maps/api';
import Loading from './Loading';
import { OpenLocationCode } from 'open-location-code';
const libraries = ['places'];

const FibreConnectMaps = ({Data}) => {
    const olc = new OpenLocationCode();
    const mapContainerStyle = {
        width: "100%",
        height: "500px",
        // border: '1px solid #ff0f64',
        boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px"
    }    //const [zoom, setZoom] = useState(15);

    let zoom = 15;
    if (!Array.isArray(Data))
        Data = [Data];
    const [center, setCenter] = useState({lat: 0, lng: 0});
    const [selectedMarker, setSelectedMarker] = useState("")
    useEffect(() => {
        try{
            let x = olc.decode(Data[0].plusCODE).latitudeCenter;
            let y = olc.decode(Data[0].plusCODE).longitudeCenter;
            setCenter({lat: parseFloat(x), lng: parseFloat(y)})
            // console.log("setted center", {lat: parseFloat(x), lng: parseFloat(y)})
        }
        catch(e){
            setCenter({lat: 12, lng: 42})
        }
        // eslint-disable-next-line
    },[])


    const {isLoaded, loadError} = useLoadScript(
        {
            googleMapsApiKey: process.env.REACT_APP_API_KEY,
            libraries
        }
    )       

    if(loadError) return "Error loading maps!";
    if(!isLoaded) return <Loading />
    return(
        <div style={{display: 'flex', justifyContent: 'center', width: '100%'}}>
            <div style={{ width: '92%', marginTop: '10px', marginBottom: '30px'}}>
                <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    zoom={zoom}
                    options={{streetViewControl: false}}
                    center={center}
                >
                    {
                        Data.map((marker) => {
                            if (!marker) return null;
                            let coordsX = olc.decode(marker.plusCODE).latitudeCenter;
                            let coordsY = olc.decode(marker.plusCODE).longitudeCenter
                            return(
                                <Marker 
                                    key={marker.COORDINATE_BUILDING+Math.random()}
                                    position={{lat: parseFloat(coordsX), lng: parseFloat(coordsY)}}
                                    onClick={() => {
                                        setSelectedMarker({lat: parseFloat(coordsX), lng: parseFloat(coordsY), address: `${marker.Indirizzo} ${marker.Numero_Civico}`})
                                    }}
                                />
                            )
                        })
                    }
                    {selectedMarker && <InfoWindow onCloseClick={(() => setSelectedMarker(""))} position={selectedMarker}>
                        <div>
                            {selectedMarker.address}
                        </div>
                    </InfoWindow>}                    
                </GoogleMap>
                <p style={{color: '#5f6a6a', marginTop: '4px'}}>*Le coordinate fornite non sono sempre esatte</p>
            </div>
        </div>       
    )
}

export default FibreConnectMaps;